import React from 'react';

const VerSubheader: React.FC = ({ children }) => (
  <React.Fragment>
    <h3>{children}</h3>
    {/* language=CSS */}
    <style jsx>{`
      h3 {
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 20px;
      }
    `}</style>
  </React.Fragment>
);

export default VerSubheader;
